import React from "react";

const ReqControlHeader = (props) => {
  const viewModeSelected = props.params.mode === "view" ? "selected" : "";
  const addModeSelected = props.params.mode === "add" ? "selected" : "";

  return (
    <div className="stat-container">
      <div
        className={`stat-content clickable ${viewModeSelected}`}
        onClick={props.params.showListHandler}
      >
        <div className="tile bg-green-l1">
          <div className="tile-label">
            <h2 className="font-bold">{props.params.approved}</h2>
            <span>Approved</span>
          </div>
          <img src="img/icon/approved.svg" alt="rejected icon" />
        </div>
        <div className="tile bg-purple">
          <div className="tile-label">
            <h2 className="font-bold">{props.params.pending}</h2>
            <span>Pending</span>
          </div>
          <img src="img/icon/time.svg" alt="rejected icon" />
        </div>
        <div className="tile bg-orange">
          <div className="tile-label">
            <h2 className="font-bold">{props.params.rejected}</h2>
            <span>Rejected</span>
          </div>
          <img src="img/icon/alert.svg" alt="rejected icon" />
        </div>

        <div className="narrow-screen btn btn-purple">
          <div>Approved : {props.params.approved}</div>
          <div>Pending : {props.params.pending}</div>
          <div>Rejected : {props.params.rejected}</div>

        </div>

      </div>
      <div className={`stat-content clickable ${addModeSelected}`} onClick={props.params.addNewClickHandler}>
        <div className="tile">
          <div className="icon-label">
            <img
              className="tile-icon"
              src="img/icon/plus.svg"
              alt="icon add Request"
            />
            {props.params.btnAddLabel}
          </div>
        </div>

        <div className="narrow-screen btn btn-blue">
          <div className="flex-center"><div>Add Request</div></div>
        </div>

      </div>
    </div>
  );
};

export default ReqControlHeader;
